import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faArrowRight,
  faArrowLeft,
  faCaretDown,
  faCheck,
  faMinus,
  faPlus,
  faXmark,
  faClock,
  faUserGroupSimple,
  faTicket,
  faCartShopping,
  faLocationPin,
  faCalendar,
  faLocationCrosshairs,
  faSquareArrowUpRight,
  faTrash,
  faCircleInfo,
  faCircleCheck,
  faPen,
  faPhone,
  faEnvelope,
  faBed,
  faUser,
  faSpinner,
  faChevronRight,
  faCircleNotch,
  faDiamonds4,
  faLock,
  faDollar,
  faDollarCircle,
  faFire,
} from '@fortawesome/sharp-solid-svg-icons';

library.add(
  faClock,
  faUserGroupSimple,
  faTicket,
  faArrowRight,
  faArrowLeft,
  faCartShopping,
  faCaretDown,
  faLocationPin,
  faCalendar,
  faCheck,
  faMinus,
  faPlus,
  faXmark,
  faLocationCrosshairs,
  faSquareArrowUpRight,
  faTrash,
  faCircleInfo,
  faCircleCheck,
  faPen,
  faPhone,
  faEnvelope,
  faBed,
  faUser,
  faSpinner,
  faChevronRight,
  faCircleNotch,
  faDiamonds4,
  faLock,
  faDollar,
  faDollarCircle,
  faFire
);
